import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MooringProfileComponent } from './mooring-profile.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRippleModule } from '@angular/material/core';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatRadioModule } from '@angular/material/radio';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { AccountsRoutingModule } from 'app/main/master-data/accounts/accounts-routing.module';
import { FuseSharedModule } from '@fuse/shared.module';

@NgModule({
  declarations: [MooringProfileComponent],
  imports: [
    CommonModule,
    AccountsRoutingModule,
    FuseSharedModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule, 
    MatSelectModule,
    MatPaginatorModule,
    MatTableModule,
    MatTabsModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatMenuModule,
    MatToolbarModule,
    MatChipsModule,
    MatExpansionModule,
    MatRippleModule,
    MatSnackBarModule,
    NgxMatSelectSearchModule,
    MatButtonToggleModule,
    MatDividerModule,
    MatTooltipModule,
    NgxMatSelectSearchModule,
    MatAutocompleteModule,
    MatRadioModule
  ],
  exports:[
    MooringProfileComponent,
  ]
})
export class MooringProfileModule { }
